// MIT License - Copyright (c) 2026 Doug McNall
const LoadingSpinner = ({ message = 'Loading...', size = 'medium' }) => {
  const sizeClass = `loading_spinner_${size}`;
  
  return (
    <div className="loading_container">
      <div className={`loading_spinner ${sizeClass}`}>
        {message}
      </div>
    </div>
  );
};

export default LoadingSpinner;
